import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error("Error de autenticación");
          navigate("/", { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data
        const response = await fetch(`${API}/auth/session?session_id=${sessionId}`, {
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Failed to authenticate");
        }

        const userData = await response.json();
        // Pass the session_token to login for localStorage backup
        login(userData, userData.session_token);
        
        toast.success(`¡Bienvenido, ${userData.name}!`);
        
        // Navigate to chat with user data
        navigate("/chat", { 
          replace: true,
          state: { user: userData }
        });
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error("Error al iniciar sesión. Por favor, intenta de nuevo.");
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="mt-6 text-slate-600 font-medium text-lg">Iniciando sesión...</p>
        <p className="mt-2 text-slate-500 text-sm">Por favor espera un momento</p>
      </div>
    </div>
  );
};

export default AuthCallback;
